// Kennzahl-Widget (Handoff Rechnungen §4): Glas, Radius 24, Label + farbiges Icon-Quadrat oben, großer Wert,
// Unterzeile, optional Zusatzzeilen (children) und blasses Wasserzeichen-Symbol. Klickbar (Filter), aktiv = Ring.
import type { ReactNode } from 'react';
import type { Icon } from '@phosphor-icons/react';

export interface KennzahlWidgetProps {
  label: string;
  wert: ReactNode;
  unter: string;
  icon: Icon;
  /** Farbe des Icon-Quadrats (Token oder Hex) */
  farbe: string;
  /** Farbe des Werts (z. B. rot bei Überfälligen) */
  wertFarbe?: string;
  /** ohne onClick reine Anzeige (kein Knopf) */
  aktiv?: boolean;
  onClick?: () => void;
  tip?: string;
  /** Balken unter dem Wert (Personal: Ist/Soll, Saldo) */
  balken?: { anteil: number; farbe: string };
  /** großes, blasses Symbol rechts unten */
  wasserzeichen?: boolean;
  children?: ReactNode;
}

export function KennzahlWidget({ label, wert, unter, icon: I, farbe, wertFarbe, aktiv = false, onClick, tip, wasserzeichen = false, balken, children }: KennzahlWidgetProps) {
  const Huelle = onClick ? 'button' : 'div';
  return (
    <Huelle type={onClick ? 'button' : undefined} onClick={onClick} aria-pressed={onClick ? aktiv : undefined} data-tip={tip}
      className={`immo-glas ${onClick ? 'immo-hover-kachel ' : ''}relative flex min-w-0 flex-col overflow-hidden text-left`}
      style={{ gap: 10, padding: '16px 18px', borderRadius: 24, border: 'none', cursor: onClick ? 'pointer' : 'default', fontFamily: 'inherit', color: 'var(--ink)',
        boxShadow: aktiv ? `inset 0 0 0 2px ${farbe}, var(--glass-sh)` : undefined }}>
      {wasserzeichen && <I aria-hidden size={92} weight="fill" className="pointer-events-none absolute" style={{ right: -10, bottom: -16, color: farbe, opacity: 0.09 }} />}
      <span className="relative flex items-center justify-between" style={{ gap: 8 }}>
        <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--ink2)' }}>{label}</span>
        <span aria-hidden className="inline-flex shrink-0 items-center justify-center" style={{ width: 34, height: 34, borderRadius: 11, background: farbe, color: '#fff' }}>
          <I size={17} weight="fill" />
        </span>
      </span>
      <span className="relative flex flex-col" style={{ gap: 2 }}>
        <span className="tabular-nums" style={{ fontSize: 30, fontWeight: 800, letterSpacing: '-0.035em', lineHeight: 1, color: wertFarbe ?? 'var(--ink)' }}>{wert}</span>
        {balken && (
          <span aria-hidden className="block overflow-hidden" style={{ height: 6, marginTop: 8, marginBottom: 4, borderRadius: 3, background: 'var(--fill2)' }}>
            <span className="block h-full" style={{ width: `${Math.max(0, Math.min(100, balken.anteil))}%`, borderRadius: 3, background: balken.farbe }} />
          </span>
        )}
        <span style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--ink3)' }}>{unter}</span>
      </span>
      {children && (
        <span className="relative flex flex-col" style={{ gap: 4, paddingTop: 10, borderTop: '1px solid var(--line)', fontSize: 12, fontWeight: 700 }}>{children}</span>
      )}
    </Huelle>
  );
}
